// extracted by mini-css-extract-plugin
module.exports = {"title":"WindStatusCard_title__2MhNO","main":"WindStatusCard_main__1R0D2","value":"WindStatusCard_value__3rJzC"};